import { CSRF_FETCHED } from "../types";


export default function navigation(state = [], action) {
  switch (action.type) {

    case CSRF_FETCHED:

      return action.data.CSRF;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/csrf.js